import { render } from "./ProfilAngajat.vue?vue&type=template&id=0f742909&scoped=true&ts=true"
import script from "./ProfilAngajat.vue?vue&type=script&lang=ts"
export * from "./ProfilAngajat.vue?vue&type=script&lang=ts"

import "./ProfilAngajat.vue?vue&type=style&index=0&id=0f742909&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f742909"]])

export default __exports__